import { makeAutoObservable } from 'mobx'

class UnAuthentStore {
  constructor() {
    makeAutoObservable(this);
  }
  // 是否已登陆
  isLogin: boolean = false;
  // 切换是否已登陆
  setIsLogin(bool: boolean) {
    this.isLogin = bool;
  }
  // 退出
  logout() {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/'
  }
}
export default new UnAuthentStore();